export const types = {
  CHANGE_AGREEMENTS: 'CHANGE_AGREEMENTS',
  SET_NAME: 'SET_NAME',
  SET_SURNAME: 'SET_SURNAME',
  SET_EMAIL: 'SET_EMAIL',
  CHANGE_OTHER_EMAIL: 'CHANGE_OTHER_EMAIL',
  SET_OTHER_EMAIL: 'SET_OTHER_EMAIL',
  SET_PHONE_NUMBER: 'SET_PHONE_NUMBER',
  SET_USER_ANSWER: 'SET_USER_ANSWER',
  HYDRATE: 'HYDRATE',
};
